import { Show, type Component, type JSX } from 'solid-js';
import { A } from '@solidjs/router';
import { isSignedIn, currentMember, currentFamily, signOut } from '~/stores/auth';
import { Button } from '~/components/ui/Button';
import * as css from './AppShell.css';

/**
 * App shell — header, main slot, footer. Used by every SPA route.
 */
export const AppShell: Component<{ children: JSX.Element }> = (props) => {
  return (
    <div class={css.shell}>
      <header class={css.header}>
        <A href="/" class={css.brand} aria-label="AETHER Kitchen">
          <span class={css.mark} aria-hidden="true">✦</span>
          <span>
            <span class={css.wordmark}>AETHER <span style={{ color: 'var(--color-accent)' }}>Kitchen</span></span>
            <small class={css.tagline}>family meal planning</small>
          </span>
        </A>
        <nav class={css.grow}>
          <Show when={isSignedIn()}>
            <A href="/plan" style={{ color: 'var(--color-text-secondary)', 'font-size': '13px', 'margin-right': '16px' }}>Plan</A>
            <A href="/family" style={{ color: 'var(--color-text-secondary)', 'font-size': '13px', 'margin-right': '16px' }}>Family</A>
            <A href="/pantry" style={{ color: 'var(--color-text-secondary)', 'font-size': '13px' }}>Pantry</A>
          </Show>
        </nav>
        <Show
          when={isSignedIn()}
          fallback={
            <Button variant="primary" size="sm" onClick={() => { window.location.href = '/signin'; }}>
              Sign in
            </Button>
          }
        >
          <SignedInChip />
        </Show>
      </header>
      <main class={css.main}>{props.children}</main>
      <footer class={css.footer}>
        <span>© AETHER Kitchen</span>
        <span>
          <a href="/privacy.html">Privacy</a> · <a href="/terms.html">Terms</a>
        </span>
      </footer>
    </div>
  );
};

const SignedInChip: Component = () => {
  const member = currentMember();
  const family = currentFamily();
  return (
    <div style={{ display: 'flex', 'align-items': 'center', gap: '10px' }}>
      <span style={{ 'font-size': '13px' }}>
        {member?.name}
        <Show when={family}>
          <span style={{ color: 'var(--color-text-tertiary)' }}> · {family!.name}</span>
        </Show>
      </span>
      <Button variant="ghost" size="sm" onClick={() => void signOut().then(() => { window.location.href = '/'; })}>
        Sign out
      </Button>
    </div>
  );
};
